import { inject, Injectable } from '@angular/core';
import { GenericApiService } from '@core/generic-api/data-access';
import { Observable } from 'rxjs';
import { IContract } from '../interface';

@Injectable({ providedIn: 'root' })
export class ContractApiService {
  static AUTHENTICATION = 'contracts-participants/authentication';
  static VERIFICATION = 'contracts-participants/verification';

  private api = inject(GenericApiService);

  authenticate(body: { refCode: string; authId: string }): Observable<{ sid: string; message: string }> {
    return this.api.post(ContractApiService.AUTHENTICATION, body);
  }

  getContractsWithOtp(body: { refCode: string; authId: string; sid: string; otpCode: string }): Observable<IContract[]> {
    return this.api.post(ContractApiService.VERIFICATION, body);
  }
}
